export const COMPANY_INFO_EMAIL = "support@staynex.vip";
export const COMPANY_MEDIA_EMAIL = "support@staynex.vip";
export const COMPANY_PARTNERSHIP_EMAIL = "support@staynex.vip";
export const COMPANY_SUPPORT_EMAIL = "support@staynex.vip";
export const COMPANY_JOIN_EMAIL = "support@staynex.vip";
export const COMPANY_DISCORD_INVITE_LINK = "https://discord.com/invite/sleap";
export const COMPANY_DISCORD_LINK = "https://discord.gg/sleap";
export const COMPANY_TWITTER_LINK = "https://twitter.com/sleap_io";
export const COMPANY_PHONE_NUMBER = "+41 62 539 10 19";
export const COMPANY_REPRESENTED = "Michael Ros";
export const COMPANY_REGISTERED_NAME = "STAYNEX PTE. LTD.";
export const COMPANY_ADDRESS_NAME = "33 UBI AVENUE 3";
export const COMPANY_ADDRESS_UNIT = "#08-43";
export const COMPANY_ADDRESS_BUILDING = "VERTEX";
export const COMPANY_ADDRESS_POSTAL_CODE = "408868";
export const COMPANY_ADDRESS_CITY = "SINGAPORE";
export const COMPANY_ADDRESS_COUNTRY = "SINGAPORE";
export const COMPANY_ADDRESS_FULL = `${COMPANY_ADDRESS_NAME}, ${COMPANY_ADDRESS_UNIT}, ${COMPANY_ADDRESS_BUILDING}, ${COMPANY_ADDRESS_COUNTRY} (${COMPANY_ADDRESS_POSTAL_CODE})`;
